import { PaginatedApiResponse } from 'types';
import { baseQuery } from '../baseQuery';
import { QueryFunctionContext } from 'react-query';

type getTechnicianTicketsParams = {
  technicianId?: string;
  page?: number;
  per_page?: number;
  status: '0' | '1' | null;

};

export const getTechnicianTickets = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianTicketsParams]>): Promise<PaginatedApiResponse<any[]>> => {
  const [, params] = queryKey;
  const { technicianId, page = 1, per_page = 10, status = 1 } = params;

  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
 // queryParams.append('filter[byStatus]', status != null ? status.toString() : '');

  status != null && queryParams.append('filter[byStatus]', status.toString());

  const url = `technicians/${technicianId}/tickets?${queryParams.toString()}`;

  const data: PaginatedApiResponse<any[]> = await baseQuery(url);

  return data;
};
